import { Component } from 'react';

export interface AccountPageListItemProps<T> {
  classes: any;
  onSelect: (item: T, tab: number) => void;
  item: T;
}

const DEFAULT_INDEX = 0;

export default class AccountPageListItem<T> extends Component<
  AccountPageListItemProps<T>
> {
  constructor(props: AccountPageListItemProps<T>) {
    super(props);
    this.selectItem = this.selectItem.bind(this);
  }

  selectItem() {
    const { item } = this.props;
    this.props.onSelect(item, DEFAULT_INDEX);
  }
}
